import { Trophy, MapPin, ShieldCheck, Zap } from "lucide-react";

const ITEMS = [
  {
    icon: Trophy,
    label: "Opiniones en Google",
    star: "(4.9★)",
    testid: "trust-bar-google-reviews",
  },
  {
    icon: MapPin,
    label: "C.C. Plaza Quil - Local 57, Guayaquil",
    testid: "trust-bar-location",
  },
  {
    icon: ShieldCheck,
    label: "Insumos y herramientas 100% garantizados",
    testid: "trust-bar-quality",
  },
  {
    icon: Zap,
    label: "Atención rápida por WhatsApp",
    testid: "trust-bar-whatsapp",
  },
];

export default function TrustBar() {
  return (
    <section className="relative z-10 bg-choco py-7 text-cream sm:py-9">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 sm:grid-cols-2 sm:px-8 lg:grid-cols-4 lg:px-12">
        {ITEMS.map((item, i) => (
          <div
            key={item.testid}
            data-testid={item.testid}
            className="flex items-center gap-4 lg:justify-center"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-cream/10 text-gold">
              <item.icon className="h-6 w-6" />
            </span>
            <p className="text-sm font-semibold leading-snug sm:text-[15px]">
              {item.label}{" "}
              {item.star && <span className="text-gold">{item.star}</span>}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
